'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vidi = require('vidi');

var _vidi2 = _interopRequireDefault(_vidi);

var _videoData = require('../utils/video-data');

var _video2 = require('../constants/events/video');

var _video3 = _interopRequireDefault(_video2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//TODO: Find source of problem with native HLS on Safari, when playing state triggered but actual playing is delayed

var STATES = exports.STATES = {
  SRC_SET: 'src-set',
  LOAD_STARTED: 'load-started',
  METADATA_LOADED: 'metadata-loaded',
  READY_TO_PLAY: 'ready-to-play',
  SEEK_STARTED: 'seek-started',
  PLAY_REQUESTED: 'play-requested',
  WAITING: 'waiting',
  SEEK_ENDED: 'seek-ended',
  PLAYING: 'playing',
  PAUSED: 'paused',
  ENDED: 'ended'
};

var Engine = function () {
  function Engine(_ref) {
    var eventEmitter = _ref.eventEmitter;

    _classCallCheck(this, Engine);

    this._eventEmitter = eventEmitter;
    this._video = document.createElement('video');
    this._vidi = new _vidi2.default(this._video);

    this._currentState = null;

    this._bindCallbacks();
    this._bindEvents();

    this.STATES = STATES;
  }

  _createClass(Engine, [{
    key: 'getNode',
    value: function getNode() {
      return this._video;
    }
  }, {
    key: '_sendError',
    value: function _sendError(error) {
      this._eventEmitter.emit(_video3.default.ERROR, error);
    }
  }, {
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._processEventFromVideo = this._processEventFromVideo.bind(this);
      this._sendError = this._sendError.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._vidi.on('error', this._sendError);

      this._video.addEventListener('loadstart', this._processEventFromVideo);
      this._video.addEventListener('loadedmetadata', this._processEventFromVideo);
      this._video.addEventListener('canplay', this._processEventFromVideo);
      this._video.addEventListener('progress', this._processEventFromVideo);
      this._video.addEventListener('play', this._processEventFromVideo);
      this._video.addEventListener('playing', this._processEventFromVideo);
      this._video.addEventListener('pause', this._processEventFromVideo);
      this._video.addEventListener('ended', this._processEventFromVideo);
      this._video.addEventListener('stalled', this._processEventFromVideo);
      this._video.addEventListener('suspend', this._processEventFromVideo);
      this._video.addEventListener('waiting', this._processEventFromVideo);
      this._video.addEventListener('durationchange', this._processEventFromVideo);
      this._video.addEventListener('timeupdate', this._processEventFromVideo);
      this._video.addEventListener('seeking', this._processEventFromVideo);
      this._video.addEventListener('seeked', this._processEventFromVideo);
      this._video.addEventListener('volumechange', this._processEventFromVideo);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._vidi.off('error', this._sendError);

      this._video.removeEventListener('loadstart', this._processEventFromVideo);
      this._video.removeEventListener('loadedmetadata', this._processEventFromVideo);
      this._video.removeEventListener('canplay', this._processEventFromVideo);
      this._video.removeEventListener('progress', this._processEventFromVideo);
      this._video.removeEventListener('play', this._processEventFromVideo);
      this._video.removeEventListener('playing', this._processEventFromVideo);
      this._video.removeEventListener('pause', this._processEventFromVideo);
      this._video.removeEventListener('ended', this._processEventFromVideo);
      this._video.removeEventListener('stalled', this._processEventFromVideo);
      this._video.removeEventListener('suspend', this._processEventFromVideo);
      this._video.removeEventListener('waiting', this._processEventFromVideo);
      this._video.removeEventListener('durationchange', this._processEventFromVideo);
      this._video.removeEventListener('timeupdate', this._processEventFromVideo);
      this._video.removeEventListener('seeking', this._processEventFromVideo);
      this._video.removeEventListener('seeked', this._processEventFromVideo);
      this._video.removeEventListener('volumechange', this._processEventFromVideo);
    }
  }, {
    key: '_processEventFromVideo',
    value: function _processEventFromVideo(event) {
      var videoEl = this._video;

      switch (event.type) {
        case 'loadstart':
          {
            this._setState(STATES.LOAD_STARTED);
            break;
          }
        case 'loadedmetadata':
          {
            this._setState(STATES.METADATA_LOADED);
            break;
          }
        case 'canplay':
          {
            this._setState(STATES.READY_TO_PLAY);
            break;
          }
        case 'play':
          {
            this._setState(STATES.PLAY_REQUESTED);
            break;
          }
        case 'playing':
          {
            this._setState(STATES.PLAYING);
            break;
          }
        case 'waiting':
          {
            this._setState(STATES.WAITING);
            break;
          }
        case 'pause':
          {
            this._setState(STATES.PAUSED);
            break;
          }
        case 'ended':
          {
            this._setState(STATES.ENDED);
            break;
          }
        case 'progress':
          {
            this._eventEmitter.emit(_video3.default.CHUNK_LOADED);
            break;
          }
        case 'stalled':
          {
            this._eventEmitter.emit(_video3.default.UPLOAD_STALLED);
            break;
          }
        case 'suspend':
          {
            this._eventEmitter.emit(_video3.default.UPLOAD_SUSPEND);
            break;
          }
        case 'durationchange':
          {
            this._eventEmitter.emit(_video3.default.DURATION_UPDATED, videoEl.duration);
            break;
          }
        case 'timeupdate':
          {
            this._eventEmitter.emit(_video3.default.CURRENT_TIME_UPDATED, videoEl.currentTime);
            break;
          }
        case 'seeking':
          {
            this._setState(STATES.SEEK_STARTED);
            break;
          }
        case 'seeked':
          {
            this._setState(STATES.SEEK_ENDED);
            break;
          }
        case 'volumechange':
          {
            this._eventEmitter.emit(_video3.default.VOLUME_STATUS_CHANGED, {
              volume: videoEl.volume,
              muted: videoEl.muted
            });
            break;
          }
        default:
          break;
      }
    }
  }, {
    key: '_setState',
    value: function _setState(state) {
      this._eventEmitter.emit(_video3.default.STATE_CHANGED, { prevState: this._currentState, nextState: state });
      this._currentState = state;
    }
  }, {
    key: 'getDebugInfo',
    value: function getDebugInfo() {
      var attachedStream = this._vidi.attachedStream;
      var _video = this._video,
          networkState = _video.networkState,
          readyState = _video.readyState;

      var data = void 0;

      if (attachedStream.hls) {
        data = this._getHLSInfo(attachedStream.hls);
      } else if (attachedStream.dashPlayer) {
        data = this._getDashInfo(attachedStream.dashPlayer);
      } else {
        data = this._getNativeInfo(this._vidi);
      }

      return _extends({
        attachedStreamName: attachedStream.constructor.name
      }, data, {
        networkState: networkState,
        readyState: readyState
      });
    }
  }, {
    key: '_getDashInfo',
    value: function _getDashInfo(dashPlayer) {
      var currentStream = dashPlayer.getActiveStream();
      var currentTime = dashPlayer.time(currentStream.getId());
      var bitrates = dashPlayer.getBitrateInfoListFor('video');
      var currentBitrate = bitrates[dashPlayer.getQualityFor('video')];
      var overallBufferLength = dashPlayer.getBufferLength('video');
      var currentTrack = dashPlayer.getCurrentTrackFor('video');
      var nearestBufferSegInfo = (0, _videoData.getNearestBufferSegmentInfo)(dashPlayer.getVideoElement().buffered, currentTime);

      return {
        dashInfo: {
          bitrates: bitrates,
          currentTime: currentTime,
          currentBitrate: currentBitrate,
          overallBufferLength: overallBufferLength,
          currentTrack: currentTrack,
          nearestBufferSegInfo: nearestBufferSegInfo
        }
      };
    }
  }, {
    key: '_getHLSInfo',
    value: function _getHLSInfo(hls) {
      var overallBufferLength = (0, _videoData.geOverallBufferLength)(hls.streamController.mediaBuffer.buffered);
      var bitrates = hls.levelController.levels;
      var currentBitrate = bitrates[hls.levelController.level];
      var currentTime = hls.streamController.lastCurrentTime;
      var nearestBufferSegInfo = (0, _videoData.getNearestBufferSegmentInfo)(hls.streamController.mediaBuffer.buffered, currentTime);

      return {
        hlsInfo: {
          bitrates: bitrates,
          currentTime: currentTime,
          currentBitrate: currentBitrate,
          overallBufferLength: overallBufferLength,
          nearestBufferSegInfo: nearestBufferSegInfo
        }
      };
    }
  }, {
    key: '_getNativeInfo',
    value: function _getNativeInfo(vidi) {
      var _vidi$videoElement = vidi.videoElement,
          buffered = _vidi$videoElement.buffered,
          currentTime = _vidi$videoElement.currentTime;


      var overallBufferLength = (0, _videoData.geOverallBufferLength)(buffered);
      var nearestBufferSegInfo = (0, _videoData.getNearestBufferSegmentInfo)(buffered, currentTime);

      return {
        nativeInfo: {
          bitrates: vidi.attachedStream.mediaStreams,
          currentBitrate: vidi.attachedStream.mediaStreams[0],
          currentTime: currentTime,
          overallBufferLength: overallBufferLength,
          nearestBufferSegInfo: nearestBufferSegInfo
        }
      };
    }
  }, {
    key: 'setSrc',
    value: function setSrc(src) {
      if (this._vidi.src !== src) {
        this._vidi.src = src;
        this._setState(STATES.SRC_SET);
      }
    }
  }, {
    key: 'getState',
    value: function getState() {
      return this._currentState;
    }
  }, {
    key: 'goForward',
    value: function goForward(sec) {
      var duration = this.getDurationTime();

      if (duration) {
        var current = this.getCurrentTime();
        this.setCurrentTime(Math.min(current + sec, duration));
      }
    }
  }, {
    key: 'goBackward',
    value: function goBackward(sec) {
      var duration = this.getDurationTime();

      if (duration) {
        var current = this.getCurrentTime();
        this.setCurrentTime(Math.max(current - sec, 0));
      }
    }
  }, {
    key: 'decreaseVolume',
    value: function decreaseVolume(value) {
      this.setVolume(this.getVolume() - value);
    }
  }, {
    key: 'increaseVolume',
    value: function increaseVolume(value) {
      this.setVolume(this.getVolume() + value);
    }
  }, {
    key: 'setAutoPlay',
    value: function setAutoPlay(isAutoPlay) {
      this._video.autoplay = Boolean(isAutoPlay);
    }
  }, {
    key: 'getAutoPlay',
    value: function getAutoPlay() {
      return this._video.autoplay;
    }
  }, {
    key: 'setLoop',
    value: function setLoop(isLoop) {
      this._video.loop = Boolean(isLoop);
    }
  }, {
    key: 'getLoop',
    value: function getLoop() {
      return this._video.loop;
    }
  }, {
    key: 'setMute',
    value: function setMute(isMuted) {
      this._video.muted = Boolean(isMuted);
    }
  }, {
    key: 'getMute',
    value: function getMute() {
      return this._video.muted;
    }
  }, {
    key: 'setVolume',
    value: function setVolume(volume) {
      var parsedVolume = Number(volume);
      this._video.volume = isNaN(parsedVolume) ? 1 : Math.max(0, Math.min(Number(volume), 1));
    }
  }, {
    key: 'getVolume',
    value: function getVolume() {
      return this._video.volume;
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this._video.playbackRate = rate;
    }
  }, {
    key: 'getPlaybackRate',
    value: function getPlaybackRate() {
      return this._video.playbackRate;
    }
  }, {
    key: 'setPreload',
    value: function setPreload(preload) {
      this._video.preload = preload || 'auto';
    }
  }, {
    key: 'getPreload',
    value: function getPreload() {
      return this._video.preload;
    }
  }, {
    key: 'getReadyState',
    value: function getReadyState() {
      return this._video.readyState;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this._video.currentTime;
    }
  }, {
    key: 'setCurrentTime',
    value: function setCurrentTime(time) {
      this._video.currentTime = time;
    }
  }, {
    key: 'getDurationTime',
    value: function getDurationTime() {
      return this._video.duration || 0;
    }
  }, {
    key: 'getBuffered',
    value: function getBuffered() {
      return this._video.buffered;
    }
  }, {
    key: 'setPlayInline',
    value: function setPlayInline(isPlayInline) {
      return this._video.setAttribute('playsInline', isPlayInline);
    }
  }, {
    key: 'getPlayInline',
    value: function getPlayInline() {
      return this._video.getAttribute('playsInline');
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this._video.remove();

      delete this._eventEmitter;
      delete this._video;

      this._vidi.setVideoElement();
      delete this._vidi;
    }
  }, {
    key: 'play',
    value: function play() {
      this._vidi.play();
    }
  }, {
    key: 'pause',
    value: function pause() {
      this._vidi.pause();
    }
  }]);

  return Engine;
}();

exports.default = Engine;
//# sourceMappingURL=playback-engine.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/playback-engine/playback-engine.js
// module id = 1224
// module chunks = 1 2 3